import CreateDocument from './CreateDocument';

const CreateKnowledge = () => {
  return <CreateDocument />
}

export default CreateKnowledge;
